import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { addMonths } from "../../helpers";

const initialState = {
  status: null,
  paid: null,
  court: null,
  locations: null,
  selectDate: [
    {
      startDate: new Date(),
      endDate: new Date(addMonths(6)),
      key: "selection",
    },
  ],
  search: "",
  sortState: {
    field: null,
    order: null,
  },
  page: 1,
  rows: 10,
  first: 0,
  lastVisitedPage: null,
};

export const bookingFilterSlice = createSlice({
  name: "bookingFilter",
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      const { filterName, value } = action.payload;
      state[filterName] = value;
    },

    setSearchTerm: (state, action) => {
      state.search = action.payload;
    },

    setSortState: (state, action) => {
      state.sortState = action.payload;
    },

    setPagination: (state, action) => {
      const { page, first } = action.payload;
      state.page = page;
      state.first = first;
    },

    setLastVisitedPage: (state, action) => {
      state.lastVisitedPage = action.payload;
    },
    clearSelectDate: (state) => {
      state.selectDate = [
        {
          startDate: null,
          endDate: null,
          key: "selection",
        },
      ];
    },
    clearFilters: (state) => {
      return initialState;
    },
  },
});

export const {
  updateFilter,
  setSearchTerm,
  setSortState,
  setPagination,
  setLastVisitedPage,
  clearFilters,
  clearSelectDate,
} = bookingFilterSlice.actions;

export default bookingFilterSlice.reducer;
